import { render, staticRenderFns } from "./ownCommitteeDetail.vue?vue&type=template&id=0e057323&scoped=true&"
import script from "./ownCommitteeDetail.vue?vue&type=script&lang=js&"
export * from "./ownCommitteeDetail.vue?vue&type=script&lang=js&"
import style0 from "./ownCommitteeDetail.vue?vue&type=style&index=0&id=0e057323&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e057323",
  null
  
)

export default component.exports